import { minifyString } from './index.js';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-var */
/* eslint-disable func-style */
/* eslint-disable func-names */
/* eslint-disable no-implicit-coercion */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-rest-params */
/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
const defineYandexMetricsCode = function (m, e, t, r, i, k, a) {
    m[i] =
        m[i] ||
            function () {
                (m[i].a = m[i].a || []).push(arguments);
            };
    m[i].l = 1 * new Date();
    (k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a);
};
const initYandexMetrics = function (w, d, l, id, childIframe, defer, webvisor) {
    w.ym(id, 'init', {
        childIframe: childIframe,
        defer: defer,
        triggerEvent: true,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: webvisor,
        trackHash: true,
        ecommerce: l,
    });
};
const defineYandexMetrics = (options, dataLayer) => {
    const { id, webvisor = false, childIframe = false, defer = false } = options;
    const response = [
        `(${defineYandexMetricsCode.toString()})(window, document, "script", "https://mc.yandex.ru/metrika/" + (typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && window.navigator.userAgent.indexOf('TA/') !== -1 ? "tag_turboapp.js" : "tag.js") , "ym")`,
        `(${initYandexMetrics.toString()})(window,document,'${dataLayer}', '${id}', ${childIframe}, ${defer}, ${webvisor})`,
    ];
    return minifyString(response.join(';\n'));
};

export { defineYandexMetrics, initYandexMetrics };
//# sourceMappingURL=yandex.js.map
